var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "keymap-extra-options" },
    [
      _c(
        "VButton",
        {
          ref: "button",
          staticClass: "keymap-settings-button",
          on: {
            mouseover: function ($event) {
              return _vm.loadSettings()
            },
            click: function ($event) {
              return _vm.toggleSettings()
            },
          },
        },
        [
          _c("VIcon", {
            attrs: { icon: "mdi-keyboard-settings-outline", size: 18 },
          }),
          _vm._v("\n    快捷键设置\n  "),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }